export default "__VITE_ASSET__CH86BOYa__"